import { inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, objectSpread as _objectSpread, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import styled from 'styled-components';
import ndsTokens from 'nicollet-tokens';
import { ndsFontReset } from '../../utilities/styles/fontUtils.js';
import 'react-is-deprecated';
import { getDeprecatedPropValue } from '../../utilities/misc/misc.js';
import { flushDOM } from '../../utilities/animation/animation.js';
import ReactModal from 'react-modal';
import ModalCloseButton from './ModalCloseButton.js';
import HiddenCloseButton from './HiddenCloseButton.js';
import { transX, transY } from './transform.js';

if (typeof window !== 'undefined') {
  ReactModal.setAppElement(document.getElementById('root'));
}

var StyledReactModal = styled(ReactModal).withConfig({
  displayName: "Modal__StyledReactModal",
  componentId: "sc-1a8xrke-0"
})(["", ";top:", ";"], ndsFontReset(), function (props) {
  return props.modalOffsetTop;
}); // NOTE: This is not the standard way of adding styles to components
// Modal is getting different treatment because of how the
// underneath component (react-modal) allows style overrides.
// Please see the README for how to style components normally

var defaultContentStyles = {
  position: 'absolute',
  background: ndsTokens.colors.background.default,
  borderRadius: '4px',
  top: '50%',
  left: '50%',
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%',
  width: '85%',
  maxWidth: '700px',
  maxHeight: '85%',
  padding: ndsTokens.space.generic['3x'],
  color: ndsTokens.colors.text.onLight.primary
};
var fullScreenStyles = {
  top: 0,
  left: 0,
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: '100%',
  borderRadius: '0',
  boxSizing: 'border-box'
};

var offsetStyles = function offsetStyles(modalOffsetTop) {
  return {
    top: modalOffsetTop
  };
};

var defaultCloseButtonStyles = {
  position: 'absolute',
  top: ndsTokens.space.generic['3x'],
  right: ndsTokens.space.generic['3x']
}; // Lifecyle methods

var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));
    _this.setModalRef = _this.setModalRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.defaultOnOpen = _this.defaultOnOpen.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {
      modalRef: null
    };
    return _this;
  }

  _createClass(Modal, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      ReactModal.setAppElement('body');
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // Stop unnecessary renders if content is not visible
      return this.props.isOpen || nextProps.isOpen;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // Set focus to the modal content container
      // TODO: Remove this once it is fixed in react-modal project itself
      if (!this.props.isOpen || this.props.disableImplicitModalFocus) return;
      var modal = this.state.modalRef;
      if (!modal) return; // Do not steal focus if it's already there

      if (!modal.contains(document.activeElement)) {
        var h2 = modal.querySelector('h2');

        if (h2 !== null) {
          h2.tabIndex = 0;
          h2.focus();
        } else {
          modal.focus();
        }
      }
    }
  }, {
    key: "setModalRef",
    value: function setModalRef(el) {
      this.setState({
        modalRef: el
      });
    } // This function is here to ensure that the layout will refresh when the modal opens, which is necessary for entrance animation

  }, {
    key: "defaultOnOpen",
    value: function defaultOnOpen(event) {
      flushDOM();
      if (this.props.onOpen) this.props.onOpen(event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          onClose = _this$props.onClose,
          onOpen = _this$props.onOpen,
          children = _this$props.children,
          offsetTop = _this$props.offsetTop,
          overlayOffsetTop = _this$props.overlayOffsetTop,
          modalOffsetTop = _this$props.modalOffsetTop,
          closeButton = _this$props.closeButton,
          closeable = _this$props.closeable,
          contentStyles = _this$props.contentStyles,
          closeButtonStyles = _this$props.closeButtonStyles,
          fullScreen = _this$props.fullScreen,
          hasCustomCloseButton = _this$props.hasCustomCloseButton,
          variant = _this$props.variant,
          restProps = _objectWithoutProperties(_this$props, ["isOpen", "onClose", "onOpen", "children", "offsetTop", "overlayOffsetTop", "modalOffsetTop", "closeButton", "closeable", "contentStyles", "closeButtonStyles", "fullScreen", "hasCustomCloseButton", "variant"]);

      var providedOverlayTop = getDeprecatedPropValue('offsetTop', 'overlayOffsetTop', this.props);
      var styles = {
        overlay: {
          top: providedOverlayTop === undefined ? '0' : providedOverlayTop,
          background: ndsTokens.layering.overlay.modal,
          zIndex: '1050'
        },
        content: _objectSpread({}, defaultContentStyles, fullScreen ? fullScreenStyles : {}, contentStyles, modalOffsetTop ? offsetStyles(modalOffsetTop) : {}),
        closeButton: _objectSpread({}, defaultCloseButtonStyles, closeButtonStyles)
      };
      return React.createElement(StyledReactModal, _extends({
        contentRef: this.setModalRef,
        isOpen: isOpen,
        onRequestClose: onClose,
        onAfterOpen: this.defaultOnOpen,
        style: styles,
        shouldFocusAfterRender: false
      }, restProps), children, closeable && !hasCustomCloseButton && (closeButton ? React.createElement(ModalCloseButton, {
        style: styles.closeButton,
        onClick: onClose,
        variant: variant
      }) : React.createElement(HiddenCloseButton, {
        onClick: onClose
      }, "close")));
    }
  }]);

  return Modal;
}(Component);

Modal.displayName = 'Modal';
Modal.defaultProps = {
  offsetTop: '0',
  overlayOffsetTop: '0',
  closeButton: true,
  closeable: true,
  hasCustomCloseButton: false,
  variant: 'standard'
};
// Basic transform animation for entry of content
// WARNING: these styles have the tendency to fail if delivered via AsynchronousComponents,
// so please ensure that critical positioning styles are added directly to your Modal implementation.
//eslint-disable declaration-colon-newline-after
var StyledModal = styled(Modal).withConfig({
  displayName: "Modal__StyledModal",
  componentId: "sc-1a8xrke-1"
})(["@keyframes delay-overflow{0%{overflow-y:hidden;}99%{overflow-y:hidden;}100%{overflow-y:auto;}}&.ReactModal__Content{opacity:0;transform:translate(", ",", ") scale(0.75);transition:opacity 300ms,transform 500ms;}&.ReactModal__Content--after-open{opacity:1;transform:translate(", ",", ") scale(1);overflow-y:auto;animation:500ms delay-overflow;}"], function (props) {
  return transX(props);
}, function (props) {
  return transY(props);
}, function (props) {
  return transX(props);
}, function (props) {
  return transY(props);
});
StyledModal.displayName = 'Modal';

export default StyledModal;
export { StyledModal as Modal };
